import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3944";

export interface SetPinRequest {
  pin: string;
}

export interface VerifyPinRequest {
  pin: string;
}

export const setSecurityPin = async (pinData: SetPinRequest): Promise<void> => {
  const token = localStorage.getItem("token");
  const response = await axios.post(`${API_URL}/auth/set-pin`, pinData, {
    headers: { Authorization: `Bearer ${token}` },
  });
  return response.data;
};

export const verifySecurityPin = async (pinData: VerifyPinRequest): Promise<boolean> => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.post(`${API_URL}/auth/verify-pin`, pinData, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.valid;
  } catch (error) {
    return false;
  }
};

export const hasSecurityPin = async (): Promise<boolean> => {
  const token = localStorage.getItem("token");
  try {
    const response = await axios.get(`${API_URL}/auth/has-pin`, {
      headers: { Authorization: `Bearer ${token}` },
    });
    return response.data.has_pin;
  } catch (error) {
    return false;
  }
};

// userService.ts - Ajouter ces fonctions

export interface ResetPinRequest {
  merchant_code: string;
  email?: string;
  phone?: string;
}

export interface VerifyResetRequest {
  merchant_code: string;
  token: string;
  new_pin: string;
}

// Demander une réinitialisation de PIN
export const requestPinReset = async (resetData: ResetPinRequest): Promise<{ message: string }> => {
  const response = await axios.post(`${API_URL}/auth/request-pin-reset`, resetData);
  return response.data;
};

// Vérifier le token et définir un nouveau PIN
export const verifyPinReset = async (verifyData: VerifyResetRequest): Promise<{ message: string }> => {
  const response = await axios.post(`${API_URL}/auth/verify-pin-reset`, verifyData);
  return response.data;
};

// Vérifier si l'utilisateur a un PIN (sans erreur bloquante)
export const checkSecurityPin = async (): Promise<boolean> => {
  try {
    const response = await axios.get(`${API_URL}/auth/has-security-pin`);
    return response.data.has_pin;
  } catch (error) {
    console.warn('Error checking PIN status, assuming no PIN:', error);
    return false;
  }
};